module.exports = __webpack_public_path__ + "media/images/icon-square-purple-3ffc6de8367556273961d69b7a96dd2c.svg";